import React, { useEffect, useRef, useState } from "react";
import { Info } from "lucide-react";

/**
 * VerifiedExplainer — Iteration 265.
 * Small (i) popover shown next to "Adult Verified" badges so first-time
 * buyers understand the trust signal. Click/tap to toggle; closes on
 * outside tap. preventDefault/stopPropagation keep it safe inside links.
 */
export const ADULT_VERIFIED_EXPLAINER =
  "Adult Verified means this parent's account has been verified to ensure a safe, trusted community for kids and families.";

export default function VerifiedExplainer({ testId = "adult-verified-explainer" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("touchstart", onDoc);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("touchstart", onDoc);
    };
  }, [open]);

  return (
    <span className="relative inline-flex items-center" ref={ref}>
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
        className="inline-flex items-center justify-center text-emerald-700 hover:text-emerald-900 transition ml-1"
        data-testid={`${testId}-toggle`}
        aria-label="What does Adult Verified mean?"
        aria-expanded={open}
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute z-30 left-1/2 -translate-x-1/2 bottom-full mb-2 w-56 rounded-xl bg-slate-900 text-white text-[11px] leading-relaxed px-3 py-2 shadow-lg text-left normal-case tracking-normal font-normal"
          data-testid={`${testId}-popover`}
        >
          {ADULT_VERIFIED_EXPLAINER}
        </span>
      )}
    </span>
  );
}
